/**
 * Error message component that is used alongside form inputs.
 * It should only be used alongside form inputs.
 *
 * Aria Live: polite - The screen reader will announce the message when the user is idle.
 * This is useful for error messages that are not critical.
 *
 * For critical error messages, use the Alert component. This uses role="alert" for the screen reader to announce the message immediately.
 *
 * @param {node} children - The children of the component (required).
 * @param {string} id - The id of the component (required).
 */
const ErrorMessage = ({ children, id }) => (
  <span
    className="mt-1 ml-1 flex items-center text-xs font-medium tracking-wide text-red-500"
    aria-live="polite"
    id={id}
  >
    {children}
  </span>
);

export default ErrorMessage;
